function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SpriteSymbol = /*#__PURE__*/function () {
  function SpriteSymbol(_ref) {
    var id = _ref.id,
        viewBox = _ref.viewBox,
        content = _ref.content;

    _classCallCheck(this, SpriteSymbol);

    this.id = id;
    this.viewBox = viewBox;
    this.content = content;
  }
  /**
   * @return {string}
   */


  _createClass(SpriteSymbol, [{
    key: "stringify",
    value: function stringify() {
      return this.content;
    }
    /**
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.stringify();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this = this;

      ['id', 'viewBox', 'content'].forEach(function (prop) {
        return delete _this[prop];
      });
    }
  }]);

  return SpriteSymbol;
}();

export { SpriteSymbol as default };